/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_Empty_BodyInputs */

const en_portalnotify_empty_body = /** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates from the team about your projects, invoices and approvals appear here.`)
};

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const ar_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const he_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const ur_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const es_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const fr_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const de_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const pt_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const hi_portalnotify_empty_body = en_portalnotify_empty_body;

/** @type {(inputs: Portalnotify_Empty_BodyInputs) => LocalizedString} */
const bn_portalnotify_empty_body = en_portalnotify_empty_body;

/**
* | output |
* | --- |
* | "Updates from the team about your projects, invoices and approvals appear here." |
*
* @param {Portalnotify_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_empty_body = /** @type {((inputs?: Portalnotify_Empty_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_Empty_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_empty_body(inputs)
	if (locale === "he") return he_portalnotify_empty_body(inputs)
	if (locale === "ur") return ur_portalnotify_empty_body(inputs)
	if (locale === "es") return es_portalnotify_empty_body(inputs)
	if (locale === "fr") return fr_portalnotify_empty_body(inputs)
	if (locale === "de") return de_portalnotify_empty_body(inputs)
	if (locale === "pt") return pt_portalnotify_empty_body(inputs)
	if (locale === "hi") return hi_portalnotify_empty_body(inputs)
	if (locale === "bn") return bn_portalnotify_empty_body(inputs)
	return /** @type {LocalizedString} */ ("Updates from the team about your projects, invoices and approvals appear here.")
});